import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTasks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTasks"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM11 8.5H17V10.5H11V8.5ZM11 13.5V15.5H17V13.5H11ZM9.5 9.5C9.5 10.1904 8.94036 10.75 8.25 10.75C7.55964 10.75 7 10.1904 7 9.5C7 8.80964 7.55964 8.25 8.25 8.25C8.94036 8.25 9.5 8.80964 9.5 9.5ZM8.25 15.75C8.94036 15.75 9.5 15.1904 9.5 14.5C9.5 13.8096 8.94036 13.25 8.25 13.25C7.55964 13.25 7 13.8096 7 14.5C7 15.1904 7.55964 15.75 8.25 15.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTasks;
